'use strict'

import game from './game'
import keno from './keno'

export default { game, keno }



// WEBPACK FOOTER //
// ./resources/assets/js/keno/api/index.js